import { BRAND } from "@/lib/brand";
import { useLang } from "@/lib/i18n";

export const Clients = () => {
  const { t } = useLang();
  const partners = BRAND.partners || [];
  if (partners.length === 0) return null;
  const loop = [...partners, ...partners];

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative isolate overflow-hidden border-y border-[color:var(--rule)] bg-[color:var(--ivory)] py-18 sm:py-22"
    >
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <div className="mb-16 flex flex-col items-start justify-between gap-8 sm:mb-20 sm:flex-row sm:items-end">
          <div>
            <div className="eyebrow mb-4">{t.clients.eyebrow}</div>
            <h2
              data-testid="clients-headline"
              className="font-display text-[28px] leading-[1.1] text-[color:var(--ink)] sm:text-[34px] lg:text-[42px]"
            >
              {t.clients.title_a}{" "}
              <span className="font-serif-accent italic text-[color:var(--emerald)]">
                {t.clients.title_b}
              </span>
            </h2>
          </div>
          <div className="font-mono-accent text-[11px] uppercase tracking-[0.22em] text-[color:var(--muted)]">
            {t.clients.meta}
          </div>
        </div>
      </div>

      <div className="relative">
        <div
          data-testid="clients-marquee"
          className="marquee-fast flex w-max items-center whitespace-nowrap"
        >
          {loop.map((p, i) => (
            <div
              key={i}
              data-testid={`client-tile-${i % partners.length}`}
              className="group relative flex h-24 shrink-0 items-center justify-center px-10 sm:h-28 sm:px-16 lg:h-32 lg:px-20"
            >
              {/* Vertical hairline divider */}
              <span
                aria-hidden="true"
                className="absolute inset-y-6 left-0 w-px bg-[color:var(--rule)]"
              />
              {p.src ? (
                <img
                  src={p.src}
                  alt={p.name}
                  className="max-h-14 w-auto max-w-[180px] object-contain opacity-90 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100 sm:max-h-16 sm:max-w-[220px] lg:max-h-20 lg:max-w-[240px]"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    const next = e.currentTarget.nextElementSibling;
                    if (next) next.style.display = "inline";
                  }}
                />
              ) : null}
              <span
                className="font-display text-lg tracking-tight text-[color:var(--ink)] opacity-80 transition-opacity group-hover:opacity-100 sm:text-xl lg:text-2xl"
                style={{ display: p.src ? "none" : "inline" }}
              >
                {p.name}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[color:var(--ivory)] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[color:var(--ivory)] to-transparent" />
      </div>
    </section>
  );
};
